import './select_view.js.coffee'
Namespace 'Customer.Filters'

class Customer.Filters.DropupSelectView extends Customer.Filters.SelectView
  initialize: (params) ->
    super params
    _.extend @, App.DropupSelectViewMixin
    @setUpDropup()
